import { parsePhoneNumberWithError, PhoneNumber } from "libphonenumber-js";

function isValidPhoneNumber(phoneNumber, country): [PhoneNumber | null, boolean] {
  try {
    const parseResult = parsePhoneNumberWithError(phoneNumber, {
      defaultCountry: country,
      extract: false,
    });

    if (!parseResult) {
      return [null, false];
    }

    if (parseResult.country !== country) {
      return [parseResult, false];
    }

    return [parseResult, parseResult.isValid()];
  } catch (error) {
    return [null, false];
  }
}

export default isValidPhoneNumber;
